import { isFetchCacheEnabled } from "./isFetchCacheEnabled";

export const getRevalidateTime = (revalidateTimeMinutes: number) => {
  if (isFetchCacheEnabled()) {
    return revalidateTimeMinutes * 60;
  }

  return 0;
};
